<script>
import NavBar from '@/components/HeaderMain'
import FooterBar from '@/components/FooterMain'
import SideBar from '@/components/sidebar/LeftSidebar'
export default {
  components: {
    NavBar,
    SideBar,
    FooterBar
  }
}
</script>

<template>
  <div class="dashboard">
    <nav-bar />
    <side-bar />
    <div class="lime-container">
      <slot/>
      <footer-bar />
    </div>
    
   </div>  
</template>


// WEBPACK FOOTER //
// src/layouts/Default.vue